import { useEffect, useState } from "react"
import axios from "axios"
import AppLayout from "@/components/app/AppLayout"
import { FeatureGate } from "@/components/app/FeatureGate"
import { PilotBanner } from "@/components/app/PilotBanner"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { API_BASE } from "@/config/api"
import { toast } from "sonner"

const API = API_BASE

function statusLabel(status) {
  if (status === "logged") return "jurnal"
  if (status === "sent") return "jurnal"
  return status
}

export default function Campaigns() {
  const [rows, setRows] = useState([])
  const [name, setName] = useState("")
  const [channel, setChannel] = useState("email")

  const load = () => axios.get(`${API}/campaigns`).then((r) => setRows(r.data)).catch(() => {})
  useEffect(() => { load() }, [])

  const add = async () => {
    if (!name.trim()) return
    try {
      await axios.post(`${API}/campaigns`, { name, channel })
      setName("")
      load()
      toast.success("Draft creat")
    } catch {
      toast.error("Eșuat")
    }
  }

  const logToJournal = async (id) => {
    try {
      const { data } = await axios.post(`${API}/campaigns/${id}/send`)
      load()
      toast.success(
        data.message
          || `Înregistrat în jurnal pentru ${data.recipients} destinatari (fără livrare email/SMS)`
      )
    } catch (e) {
      toast.error(e.response?.data?.detail || "Eșuat")
    }
  }

  return (
    <FeatureGate feature="campaigns" title="Marketing Suite" description="Add-on Marketing Suite (plan Clinic).">
      <AppLayout title="Campanii">
        <PilotBanner className="mb-4 max-w-xl">
          Campaniile salvează doar evenimente în jurnalul intern de comunicări. Nu există livrare prin ESP (email/SMS) încă — butonul nu trimite mesaje reale.
        </PilotBanner>
        <div className="flex flex-wrap gap-3 max-w-lg mb-6 items-end">
          <div className="flex-1 min-w-[140px]">
            <Label className="text-xs">Nume</Label>
            <Input placeholder="Nume campanie" value={name} onChange={(e) => setName(e.target.value)} className="mt-1" />
          </div>
          <div>
            <Label className="text-xs">Canal</Label>
            <Select value={channel} onValueChange={setChannel}>
              <SelectTrigger className="mt-1 w-32"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="email">Email</SelectItem>
                <SelectItem value="sms">SMS</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Button className="rounded-full" onClick={add}>Creează draft</Button>
        </div>
        <ul className="divide-y divide-border rounded-xl border border-border bg-card text-sm max-w-xl">
          {rows.map((c) => (
            <li key={c.id} className="px-4 py-3 flex justify-between items-center gap-2">
              <span>{c.name}</span>
              <span className="capitalize text-muted-foreground text-xs">{c.channel} · {statusLabel(c.status)}</span>
              {c.status === "draft" && (
                <Button size="sm" variant="outline" className="rounded-full" onClick={() => logToJournal(c.id)}>
                  Salvează în jurnal
                </Button>
              )}
            </li>
          ))}
        </ul>
      </AppLayout>
    </FeatureGate>
  )
}
